/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentCustomerOptionsPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentCustomerOptionsPageResponseOutputItemsMax = 50;

export const incidentCustomerOptionsPageResponseOutputNextCursorOneMax = 4096;

export const IncidentCustomerOptionsPageResponseOutput = zod.object({
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(incidentCustomerOptionsPageResponseOutputItemsItemIdRegExp),
        name: zod.string(),
      }),
    )
    .max(incidentCustomerOptionsPageResponseOutputItemsMax),
  nextCursor: zod.union([
    zod.string().max(incidentCustomerOptionsPageResponseOutputNextCursorOneMax),
    zod.null(),
  ]),
});

export type IncidentCustomerOptionsPageResponseOutput = zod.input<
  typeof IncidentCustomerOptionsPageResponseOutput
>;
export type IncidentCustomerOptionsPageResponseOutputOutput = zod.output<
  typeof IncidentCustomerOptionsPageResponseOutput
>;
